import { http, HttpResponse } from "msw";

export const findingHandlersStatic = [
  http.put("*/api/agent/deployments/:deploymentId/issues/:id", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),
  http.get("*/api/agent/deployments/:deploymentId/issues/:id", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),
  http.get("*/api/agent/deployments/:deploymentId/issues/v2/:id", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),

  http.put("*/api/agent/deployments/:deploymentId/issues*", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),

  http.put("*/api/secrets/deployments/:deploymentId/findings*", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),

  http.get("*/api/agent/deployments/:deploymentId/issue_counts", () =>
    HttpResponse.json(
      {},
      {
        status: 200,
      }
    )
  ),
];
